import * as React from 'react';
import { useState, useEffect } from 'react';
import { Box, Grid, FormControl, Paper, Button, TextField, MenuItem, Modal, Typography, Snackbar, Alert } from '@mui/material';
import { settingApi } from "../../api/api"; // Import your API method

const WebsiteThemeColors = () => {
    const [theme, setTheme] = useState("");  
    const [themeType, setThemeType] = useState("light"); // Default to "light" 
    const [primaryColor, setPrimaryColor] = useState("#ff5733");
    const [secondaryColor, setSecondaryColor] = useState("#33c1ff");
    const [themeColor, setThemeColor] = useState("#3498db"); 
    const [loading, setLoading] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const [availableThemes, setAvailableThemes] = useState([]);
    const [availableThemeTypes, setAvailableThemeTypes] = useState([]);
  const [primaryTextColor, setPrimaryTextColor] = useState("#E0E0E0");
  const [secondaryTextColor, setSecondaryTextColor] = useState("#B0B0B0");
  const [primaryGradientStartColor, setPrimaryGradientStartColor] = useState("#121212");
  const [primaryGradientEndColor, setPrimaryGradientEndColor] = useState("#232323");
  const [chipBackgroundColor, setChipBackgroundColor] = useState("#333333");
  const [backArrowColor, setBackArrowColor] = useState("#FFFFFF");
  const [borderColor, setBorderColor] = useState("#444444");
  const [background, setBackground] = useState("#181818");
  const [linkColor, setLinkColor] = useState("#1E90FF");
  const [tabBarActive, setTabBarActive] = useState("#FFD700");
  const [tabBarInactive, setTabBarInactive] = useState("#808080");
  const [fontSizeLarge, setFontSizeLarge] = useState(18);
  const [fontSizeMedium, setFontSizeMedium] = useState(16);
  const [fontSizeSmall, setFontSizeSmall] = useState(14);
  const [mainIcon,setMainIcon]=useState("#FFFFFF");
  const [normalIcon,setNormalIcon]=useState("#fffff");
  const [screenBackground,setScreenBackground]=useState("black");

    // Modal state
    const [openModal, setOpenModal] = useState(false);
    const [newColor, setNewColor] = useState("");

    const toggleTheme = () => {
        setThemeType((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
    };
    
    // Example button to switch themes
    <button onClick={toggleTheme}>Toggle Theme</button>
    

    // Fetch theme data from API on component mount
    useEffect(() => {
        const getAllThemes = async () => {
            try {
                const response = await settingApi.getTheme();  // Assuming this API gets the available themes
                const data = response.data;
                setAvailableThemes(data);

                if (data.length > 0) {
                    const firstTheme = data[0].theme_name;
                    setTheme(firstTheme);
                    setThemeColor(getThemeColorBasedOnType(firstTheme)); 
                }
            } catch (error) {
                console.error("Failed to fetch theme data:", error);
                setSnackbarMessage("Failed to fetch theme data");
                setSnackbarSeverity("error");
                setSnackbarOpen(true);
            }
        };
        getAllThemes();
    }, []);


    const fetchColorsForThemeType = async (themeType) => {
        try {
            // Here we use the API data to set the primary and secondary colors based on the themeType
            const selectedTheme = availableThemeTypes.find(theme => theme.theme_type === themeType);
            
            if (selectedTheme) {
                setPrimaryColor(selectedTheme.primarytext_color);  // Update primary text color
                setSecondaryColor(selectedTheme.secondarytext_color);  // Update secondary text color
            } else {
                console.error("Invalid theme type");
            }
        } catch (error) {
            console.error("Failed to fetch colors:", error);
            setSnackbarMessage("Failed to fetch colors");
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        }
    };

    // Function to handle theme color based on type
    const getThemeColorBasedOnType = (themeType) => {
        // Define a color scheme based on theme type
        if (themeType === "Dark") {
            return "#2c3e50";  // Dark color
        } else if (themeType === "Light") {
            return "#3498db";  // Light color (Blue)
        }
        return "#3498db";  // Default color (Blue)
    };

    const handleChangeThemeType = (event) => {
        const selectedThemeType = event.target.value;
        setThemeType(selectedThemeType);
        fetchColorsForThemeType(selectedThemeType);  // Fetch new colors based on theme type
        setThemeColor(getThemeColorBasedOnType(selectedThemeType));  // Update theme color
    };

    const handlePrimaryColorChange = (event) => {
        setPrimaryColor(event.target.value);
    };
    const handlePrimaryTextColorChange = (event) => {
        setPrimaryTextColor(event.target.value);
    };
    const handleSecondaryColorChange = (event) => {
        setSecondaryColor(event.target.value);
    };
    const handleSecondaryTextColorChange = (event) => {
        setSecondaryTextColor(event.target.value);
    };
    const handlePrimaryGradientStartColorChange = (event) => {
        setPrimaryGradientStartColor(event.target.value);
    };
    const handlePrimaryGradientEndColorChange = (event) => {
        setPrimaryGradientEndColor(event.target.value);
    };
    const handlechipBackgroundColorChange=(event)=>{
        setChipBackgroundColor(event.target.value);
    }
    const handleBackArrowColorChange=(event)=>{
        setBackArrowColor(event.target.value);
    }
    const handleBorderColorChange=(event)=>{
        setBorderColor(event.target.value);
    }
    const handleBackgroundChange=(event)=>{
        setBackground(event.target.value);
    }
    const handleLinkColorChange=(event)=>{
        setLinkColor(event.target.value);
    }
    const handleTabBarActiveColorChange=(event)=>{
        setTabBarActive(event.target.value);
    }
    const handleTabBarInActiveColorChange=(event)=>{
        setTabBarInactive(event.target.value);
    }
    const handleMainIconChange=(event)=>{
        setMainIcon(event.target.value);
    }
    const handleNormalIconChange=(event)=>{
        setNormalIcon(event.target.value);
    }
    const handleScreenBackgroundChange=(event)=>{
        setScreenBackground(event.target.value);
    }

    

    const handleThemeColorChange = (event) => {
        setThemeColor(event.target.value);
    };

    const handleSave = async (event) => {
        event.preventDefault();
        setLoading(true);
    
        const fd = new FormData();
        fd.append("theme_type", themeType);  // Append selected theme type
        fd.append("primary_color", primaryColor);  // Append primary color
        fd.append("text", secondaryColor);  // Append secondary color
        fd.append("theme_name", theme);  // Append theme color
        fd.append("primary_text_color",primaryTextColor);
        fd.append("secondary_text_color",secondaryTextColor);
        fd.append("primary_gradient_start_color",primaryGradientStartColor);
        fd.append("primary_gradient_end_color",primaryGradientEndColor);
        fd.append("chip_background_color",chipBackgroundColor);
        fd.append("back_arrow_color",backArrowColor);
        fd.append("borderColor",borderColor);
        fd.append("background",background);
        fd.append("link_color",linkColor);
        fd.append("tab_bar_active",tabBarActive);
        fd.append("tab_bar_inactive",tabBarInactive);
        fd.append("fontsize_large",fontSizeLarge);
        fd.append("fontsize_medium",fontSizeMedium);
        fd.append("fontsize_small",fontSizeSmall);
        fd.append("main_icon",mainIcon);
        fd.append("normal_icon",normalIcon);
        fd.append("screen_background",screenBackground);
        for (let pair of fd.entries()) {
            console.log(pair[0] + ": " + pair[1]);
        }
        
        try {
            // Send the form data to your backend API
            const response = await settingApi.addWebsiteThemeColors(fd); 
            if (response.status === 201) {
                setSnackbarMessage("Theme Changed successfully!");
                setSnackbarSeverity("success");
                setSnackbarOpen(true);
                resetForm();  // Reset the form fields after successful save
            } else {
                throw new Error("Failed to change theme");
            }
        } catch (error) {
            // If the API call fails, show an error message
            setSnackbarMessage("Failed to change theme. Please try again.");
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
            // console.error(error.message);
        } finally {
            setLoading(false);  // Set loading to false once the operation is complete
        }
    };
   

    const resetForm = () => {
        setThemeType("Light");
        setPrimaryColor("#fdd733");
        setSecondaryColor("#34c1ff");
        setThemeColor("#3498db");
    };

    const handleAddNewColor = () => {
        if (newColor) { // Check for valid hex color
            // const theme_name=newColor;
            // console.log(theme_name);
            const fd = new FormData();
            fd.append("theme_name",newColor);
            // console.log(theme_name);
            
                const response=settingApi.addTheme(fd);
               
            
            setAvailableThemes([...availableThemes, { theme_name: newColor, is_active: 1 }]);
            setOpenModal(false);
            setNewColor("");
        } else {
            setSnackbarMessage("Please enter a valid color code.");
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        }
    };

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, px: 2 }}>
            <div className="dashboard section_space_bottom">
                <Box sx={{ flexGrow: 1 }} style={{ border: '2px solid lightgray', borderRadius: '5px' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <h1 style={{ margin: '20px 20px' }}>Settings</h1>
                        </Grid>
                    </Grid>
                </Box>
                <Paper elevation={12} sx={{ padding: 3 }}>
                    <form onSubmit={handleSave}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <FormControl fullWidth sx={{ marginRight: 2 }}>
                                    <TextField
                                        select
                                        label="Select Theme Color"
                                        value={theme}
                                        onChange={(e) => setTheme(e.target.value)}
                                        variant="outlined"
                                        fullWidth
                                    >
                                        {availableThemes.map((theme) => (
                                            <MenuItem key={theme.id} value={theme.theme_name}>
                                                {theme.theme_name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </FormControl>

                                <Button
                                    variant="outlined"
                                    onClick={() => setOpenModal(true)}
                                    sx={{ whiteSpace: 'nowrap', height: '100%' }}
                                >
                                    Add New
                                </Button>
                            </Grid>

                            

<Grid item xs={12}>
  <FormControl fullWidth>
    <TextField
      select
      label="Theme Type"
      value={themeType}
      onChange={(e) => setThemeType(e.target.value)} // Handle theme type change
      variant="outlined"
      fullWidth
    >
      <MenuItem value="light">Light</MenuItem>
      <MenuItem value="dark">Dark</MenuItem>
    </TextField>
  </FormControl>
</Grid>


                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        type="color"
                                        value={primaryColor}
                                        onChange={handlePrimaryColorChange}
                                        variant="outlined"
                                        fullWidth
                                    />
                                    <p>Primary Color Code: <span style={{ fontWeight: 'bold' }}>{primaryColor}</span></p>
                                </FormControl>
                            </Grid>

                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        type="color"
                                        value={secondaryColor}
                                        onChange={handleSecondaryColorChange}
                                        variant="outlined"
                                        fullWidth
                                    />
                                    <p>Secondary Color Code: <span style={{ fontWeight: 'bold' }}>{secondaryColor}</span></p>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        type="color"
                                        value={primaryTextColor}
                                        onChange={handlePrimaryTextColorChange}
                                        variant="outlined"
                                        fullWidth
                                    />
                                    <p>Primary Color Code: <span style={{ fontWeight: 'bold' }}>{primaryColor}</span></p>
                                </FormControl>
                            </Grid>
                            
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        type="color"
                                        value={secondaryTextColor}
                                        onChange={handleSecondaryTextColorChange}
                                        variant="outlined"
                                        fullWidth
                                    />
                                    <p>Secondary Text Color Code: <span style={{ fontWeight: 'bold' }}>{secondaryColor}</span></p>
                                </FormControl>
                            </Grid>
                          
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        type="color"
                                        value={primaryGradientStartColor}
                                        onChange={handlePrimaryGradientStartColorChange}
                                        variant="outlined"
                                        fullWidth
                                    />
                                    <p>PrimaryGradientStart Color Code: <span style={{ fontWeight: 'bold' }}>{secondaryColor}</span></p>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        type="color"
                                        value={primaryGradientEndColor}
                                        onChange={handlePrimaryGradientEndColorChange}
                                        variant="outlined"
                                        fullWidth
                                    />
                                    <p>Chip Background Color Code: <span style={{ fontWeight: 'bold' }}>{secondaryColor}</span></p>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        type="color"
                                        value={chipBackgroundColor}
                                        onChange={handlechipBackgroundColorChange}
                                        variant="outlined"
                                        fullWidth
                                    />
                                    <p>PrimaryGradientEnd Color Code: <span style={{ fontWeight: 'bold' }}>{secondaryColor}</span></p>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        type="color"
                                        value={backArrowColor}
                                        onChange={handleBackArrowColorChange}
                                        variant="outlined"
                                        fullWidth
                                    />
                                    <p>BackArrow Color Code: <span style={{ fontWeight: 'bold' }}>{secondaryColor}</span></p>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        type="color"
                                        value={borderColor}
                                        onChange={handleBorderColorChange}
                                        variant="outlined"
                                        fullWidth
                                    />
                                    <p>Border Color Code: <span style={{ fontWeight: 'bold' }}>{secondaryColor}</span></p>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        type="color"
                                        value={background}
                                        onChange={handleBackgroundChange}
                                        variant="outlined"
                                        fullWidth
                                    />
                                    <p>Background Color Code: <span style={{ fontWeight: 'bold' }}>{secondaryColor}</span></p>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        type="color"
                                        value={linkColor}
                                        onChange={handleLinkColorChange}
                                        variant="outlined"
                                        fullWidth
                                    />
                                    <p>Link Color Code: <span style={{ fontWeight: 'bold' }}>{secondaryColor}</span></p>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        type="color"
                                        value={tabBarActive}
                                        onChange={handleTabBarActiveColorChange}
                                        variant="outlined"
                                        fullWidth
                                    />
                                    <p>TabBarActive Color Code: <span style={{ fontWeight: 'bold' }}>{secondaryColor}</span></p>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        type="color"
                                        value={tabBarInactive}
                                        onChange={handleTabBarInActiveColorChange}
                                        variant="outlined"
                                        fullWidth
                                    />
                                    <p>TabBarInActive Color Code: <span style={{ fontWeight: 'bold' }}>{secondaryColor}</span></p>
                                </FormControl>
                                 <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        type="color"
                                        value={mainIcon}
                                        onChange={handleMainIconChange}
                                        variant="outlined"
                                        fullWidth
                                    />
                                    <p>Main Icon Color Code: <span style={{ fontWeight: 'bold' }}>{mainIcon}</span></p>
                                </FormControl>
                            </Grid>
                             <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        type="color"
                                        value={normalIcon}
                                        onChange={handleNormalIconChange}
                                        variant="outlined"
                                        fullWidth
                                    />
                                    <p>Normal Icon Color Code: <span style={{ fontWeight: 'bold' }}>{normalIcon}</span></p>
                                </FormControl>
                            </Grid>
                             <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        type="color"
                                        value={screenBackground}
                                        onChange={handleScreenBackgroundChange}
                                        variant="outlined"
                                        fullWidth
                                    />
                                    <p>Screen Background Color Code: <span style={{ fontWeight: 'bold' }}>{screenBackground}</span></p>
                                </FormControl>
                            </Grid>
                                <Grid container spacing={2}>
      {/* Small Font Size */}
      <Grid item xs={12}>
        <TextField
          label="Small Font Size"
          fullWidth
          type="number"
          value={fontSizeSmall}
          onChange={(e) => setFontSizeSmall(e.target.value)}
        />
      </Grid>

      {/* Medium Font Size */}
      <Grid item xs={12}>
        <TextField
          label="Medium Font Size"
          fullWidth
          type="number"
          value={fontSizeMedium}
          onChange={(e) => setFontSizeMedium(e.target.value)}
        />
      </Grid>

      {/* Large Font Size */}
      <Grid item xs={12}>
        <TextField
          label="Large Font Size"
          fullWidth
          type="number"
          value={fontSizeLarge}
          onChange={(e) => setFontSizeLarge(e.target.value)}
        />
      </Grid>
    </Grid>
                            </Grid>
                        <Grid container spacing={3} sx={{ mt: 2, display: "flex", justifyContent: "flex-end", mt: 4 }}>
                            <Grid item xs={12}>
                                <Button type="submit" variant="contained" sx={{ padding: '8px 20px' }} fullWidth disabled={loading}>
                                    {loading ? 'Saving...' : 'Save'}
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </Paper>
            </div>
            
            {/* Modal for New Color */}
            <Modal
                open={openModal}
                onClose={() => setOpenModal(false)}
                aria-labelledby="create-new-color-modal"
                aria-describedby="modal-to-create-new-color"
            >
                <Box
                    sx={{
                        padding: 3,
                        margin: 'auto',
                        backgroundColor: 'white',
                        borderRadius: 2,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '100%',
                        maxWidth: 400,
                    }}
                >
                    <Grid container spacing={3} sx={{ width: '100%' }}>
                        <Grid item xs={12}>
                            <Typography variant="h6" id="create-new-color-modal">
                                Create New Theme
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                label="Theme Name"
                                value={newColor}
                                onChange={(e) => setNewColor(e.target.value)}
                                fullWidth
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <Button
                                variant="outlined"
                                fullWidth
                                onClick={() => setOpenModal(false)}
                            >
                                Cancel
                            </Button>
                        </Grid>
                        <Grid item xs={6}>
                            <Button
                                variant="contained"
                                fullWidth
                                onClick={handleAddNewColor}
                            >
                                Add Theme
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>

            {/* Snackbar for error/success messages */}
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={() => setSnackbarOpen(false)}
            >
                <Alert
                    onClose={() => setSnackbarOpen(false)}
                    severity={snackbarSeverity}
                    sx={{ width: '100%' }}
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Box>
    );
};


export default WebsiteThemeColors;
